import { createSlice } from "@reduxjs/toolkit";

const loadPersistedBusiness = () => {
  try {
    const cached = localStorage.getItem("activeBusinessData");
    if (cached) return JSON.parse(cached);
  } catch (e) {
    console.error("Failed to parse cached business data", e);
  }
  return null;
};

const persistedBusiness = loadPersistedBusiness();

const initialState = {
  token: null,
  userId: null,
  businessId: persistedBusiness?.id || persistedBusiness?._id || null,
  businessData: persistedBusiness,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setBusinessData: (state, action) => {
      const business = action.payload;
      state.businessData = business;
      state.businessId = business?.id || business?._id || null;
      if (business) {
        localStorage.setItem("activeBusinessData", JSON.stringify(business));
      } else {
        localStorage.removeItem("activeBusinessData");
      }
    },
    clearUser: (state) => {
      state.token = null;
      state.userId = null;
      state.businessId = null;
      state.businessData = null;
      localStorage.removeItem("activeBusinessData");
    },
  },
});

export const { setToken, setUserId, setBusinessData, clearUser } =
  userSlice.actions;
export default userSlice.reducer;
